// Unauthorized.js
import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const Unauthorized = () => (
  <Box p={6} textAlign="center">
    <Text fontSize="2xl" fontWeight="bold">Unauthorized</Text>
    <Text>You do not have permission to access this page.</Text>
  </Box>
);

export default Unauthorized;
